import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { getDeviceType } from '@/utils/misc'
import type { DeviceType } from '@/utils/misc'

/** 移动端布局断点（px），视口宽度 <= 此值视为移动端 */
export const MOBILE_BREAKPOINT = 1080

/**
 * 监听视口变化，返回是否为移动端视口
 * 随窗口 resize 实时更新，无需跳转路由
 */
export function useViewport(breakpoint = MOBILE_BREAKPOINT) {
  const isMobileViewport = ref(typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false)

  const update = () => {
    if (typeof window !== 'undefined') {
      isMobileViewport.value = window.innerWidth <= breakpoint
    }
  }

  onMounted(() => {
    update()
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', update)
    window.removeEventListener('orientationchange', update)
  })

  return { isMobileViewport }
}

/**
 * 响应式设备类型：mobile / pad / pc
 * 监听窗口尺寸与横竖屏变化，自动更新。
 */
export function useDeviceType() {
  const deviceType = ref<DeviceType>(typeof window !== 'undefined' ? getDeviceType() : 'pc')

  const update = () => {
    if (typeof window !== 'undefined') {
      deviceType.value = getDeviceType()
    }
  }

  onMounted(() => {
    update()
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', update)
    window.removeEventListener('orientationchange', update)
  })

  return {
    deviceType,
    isMobileDevice: computed(() => deviceType.value === 'mobile'),
    isPadDevice: computed(() => deviceType.value === 'pad'),
    isPcDevice: computed(() => deviceType.value === 'pc'),
  }
}
